/**
 * Returns the selected element formatted as the BE expects.
 *
 * @param {object} selected - element selected in the autocomplete (citizenship or language).
 * @param {string} type - the type of banner could be citizenships or languages.
 *
 * @returns {object} - the element formatted correctly for the BE.
 */
export const formatElement = (selected, type) => {
  const element = {
    name: selected.text,
    text: selected.text
  };
  if (type === 'citizenships') {
    element.id = selected.id.substr(8);
    element.placeKey = selected.id;
  } else {
    element.id = selected.id.toString();
  }
  return element;
};

/**
 * Returns the correct banner text, depending on if it's citizenships or languages.
 *
 * @param {string} type - the type of banner could be citizenships or languages.
 *
 * @returns {string} - the banner text.
 */
export const getBannerText = (type) => {
  if (type === 'citizenships') {
    return (
      `Profiles with citizenship information appear higher in candidate search
      results and are seen by more recruiters.
      Add yours below to give your profile a boost.`
    );
  }
  return (
    `Language skills are essential for many roles in the development sector.
    Which languages do you speak?`
  );
};
